import { useEffect, useState } from "react"
import SpotifyWebApi from "spotify-web-api-node"
import { useAuth } from "../hooks/useAuth"
import { SpotPlayer } from "./SpotPlayer"
import { filterByArtist, generateRandomString } from "../helpers"
import { Canvas } from '@react-three/fiber'
import { Stars } from "./Stars"

const spotifyApi = new SpotifyWebApi({
  clientId: "971b948ffd3645aca27b3708306cb672",
})

export const Board = ({ code }) => {

  const {accessToken} = useAuth(code)
  const [searchResults, setSearchResults] = useState([])
  const [play, setPlay] = useState(true)
  const [offset, setOffset] = useState(0)
  const [currentTrack, setCurrentTrack] = useState({})
  
  useEffect(() => {
    if (!accessToken) return
    spotifyApi.setAccessToken(accessToken)
  }, [accessToken])

  useEffect(() => {
    if (!accessToken) return

    let cancel = false
    const search = generateRandomString(4)
    spotifyApi.searchTracks(search).then(res => {
      if (cancel) return
      setSearchResults(
        [...searchResults, ...res.body.tracks.items.map(track => {
          const bigestAlbumImage = track.album.images.reduce(
            (bigest, image) => {
              if (image.height > bigest.height) return image
              return bigest
            },
            track.album.images[0]
          )

          return {
            artist: track.artists[0].name,
            title: track.name,
            uri: track.uri,
            albumUrl: bigestAlbumImage.url,
          }
        })]
      )
      setOffset(searchResults.length / 2)
    })

    return () => (cancel = true)
  }, [accessToken]) // eslint-disable-line react-hooks/exhaustive-deps

  const getCurrentTrack = (uri) => {
    const i = searchResults.findIndex(el => el.uri === uri)
    setCurrentTrack(searchResults[i - 1]);
  }

  const onStarClick = () => {
    setSearchResults(searchResults.filter(track => track.uri !== currentTrack.uri))
  }

  return (
  <>
    <Canvas>
      <ambientLight />
      <pointLight position={[10, 10, 10]} />
      <Stars
        setPlay={setPlay}
        onStarClick={onStarClick}
        currentTrack={searchResults?.findIndex(el => el.uri === currentTrack?.uri) ?? 0} />
    </Canvas>
    <div>
      <SpotPlayer
        className='player'
        accessToken={accessToken}
        trackUri={filterByArtist(searchResults).map(el => el.uri)}
        play={play}
        offset={offset}
        getCurrentTrack={getCurrentTrack}
        currentTrack={currentTrack}
      />
    </div>
  </>)
}